// extracted by mini-css-extract-plugin
export default {"container":"TeamInvitation_container__WYSTi","centered":"TeamInvitation_centered__i6HPS"};